module.exports = "/_next/static/images/cabs-service-1-f6d74de319836678ee36f05caa40b548.webp";